"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isArray = isArray;
exports.isObject = isObject;
/**
 * @Author: Alexander Silva Barbosa
 * @Date:   2022-09-29 15:58:26
 * @Last Modified by:   Alexander Silva Barbosa
 * @Last Modified time: 2022-09-29 15:59:56
 */

function isObject(o) {
  return o !== null && typeof o === 'object' && Array.isArray(o) === false;
}
function isArray(o) {
  return o !== null && typeof o === 'object' && Array.isArray(o) === true;
}